// Import model
import { DataviewOrganizationResponse } from '../models/DataviewOrganizationResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOrganizationRequest } from '../models/FilterOrganizationRequest';
import { Organization } from '../models/Organization';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOrganizationRequestSerializer } from './FilterOrganizationRequestSerializer';
import { OrganizationSerializer } from './OrganizationSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOrganizationResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOrganizationResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOrganizationResponse instance
   */
  static deserialize(json: string): DataviewOrganizationResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOrganizationResponse instance
   */
  static fromObject(obj: any): DataviewOrganizationResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOrganizationResponse');
    }


    const instance: DataviewOrganizationResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OrganizationSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOrganizationRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOrganizationResponse instances
   */
  static deserializeArray(json: string): DataviewOrganizationResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOrganizationResponse instance to a JSON string
   */
  static serialize(instance: DataviewOrganizationResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOrganizationResponse instance to a plain object
   */
  static toObject(instance: DataviewOrganizationResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OrganizationSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOrganizationRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOrganizationResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOrganizationResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
